
import { defineComponent, computed } from 'vue'
import currency from '@/filters/currency'
import { store } from '@/store'
import InvoiceSteps from '@/components/InvoiceSteps.vue'

export default defineComponent({
  name: 'InvoiceCompleted',
  setup() {
    return {
      currency,
      invoice: computed(() => store.state.invoice),
      steps: computed(() => store.state.steps),
    }
  },
  components: {
    InvoiceSteps,
  },
})
